import {
	MarketplaceOrderEditOrderStepForm,
	MarketplaceOrderEditOrderLinesStepForm,
	MarketplaceOrderEditShippingStepForm,
	MarketplaceOrderEditAssignmentStepForm,
} from 'modules/order/forms/wizard';
import { FormBase } from 'core/components';
import _ from 'lodash';

export default class MarketplaceOrderEditForm extends FormBase {
	formFields = null;

	constructor(hooks) {
		super(hooks);
		this.formFields = this.getForm().fields;
	}

	getForm() {
		const orderStep = MarketplaceOrderEditOrderStepForm(),
			orderLinesStep = MarketplaceOrderEditOrderLinesStepForm(),
			shippingStep = MarketplaceOrderEditShippingStepForm(),
			assignmentStep = MarketplaceOrderEditAssignmentStepForm();
		let fields = _.concat(orderStep.fields, orderLinesStep.fields, shippingStep.fields, assignmentStep.fields);
		delete orderStep.fields;
		delete orderLinesStep.fields;
		delete shippingStep.fields;
		delete assignmentStep.fields;
		let form = _.merge(orderStep, orderLinesStep, shippingStep, assignmentStep);
		this.formFields = fields;
		form.fields = fields;
		return form;
	}
	setup() {
		var form = this.getForm();
		return {
			fields: form.fields,
			defaults: form.defaults,
			initials: form.initials,
			values: form.values,
			labels: form.labels,
			placeholders: form.placeholders,
			rules: form.rules,
			extra: form.extra,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditForm.js